import { CCString, _decorator } from 'cc';
import ButtonSoundEffect from '../Button/ButtonEventEffect/ButtonSoundEffect';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, menu, requireComponent } = _decorator;

@ccclass('MultiThemeButtonSoundEffect')
@menu('MultiTheme/MultiThemeButtonSoundEffect')
@requireComponent(ButtonSoundEffect)
export default class MultiThemeButtonSoundEffect extends MultiThemeComponent<ButtonSoundEffect> {
    @property({ type: [CCString] })
    private readonly audioClipKeys: string[] = [];

    public getMaxTheme(): number {
        return this.audioClipKeys.length;
    }

    protected getTarget() {
        return this.getComponent(ButtonSoundEffect);
    }

    protected onThemeChanged() {
        this.target.audioClipKey = this.audioClipKeys[this._theme];
    }
}
